import axios from "axios";
import { config } from "../../utils/axiosconfig";
import { base_url } from "../../utils/baseUrl";

const getIndustrialvisit = async () => {
  const response = await axios.get(`${base_url}industrialvisit`, config);

  return response.data;
};
const getIndustrialvisitmenu = async () => {
  const response = await axios.get(`${base_url}industrialvisit`, config);

  return response.data;
};
const industrialService = {
  getIndustrialvisit,
  getIndustrialvisitmenu,
};

export default industrialService;
